import { FloatingList } from '@floating-ui/react'
import classNames from 'classnames'

import { LoaderListItem } from '../../ListItem'
import { SelectDropdownAsyncListInitialLoader } from '../SelectDropdownAsyncListInitialLoader'
import { SelectDropdownEmpty } from '../SelectDropdownEmpty'
import { SelectDropdownEntityListItem } from '../SelectDropdownEntityListItem'
import { SelectDropdownListContainer } from '../SelectDropdownListContainer'

import {
  showSelectDropdownAsyncListFooter,
  showSelectDropdownAsyncListHeader,
} from './SelectDropdownAsyncList.utils'

import * as styles from './SelectDropdownAsyncList.module.css'

function SelectDropdownAsyncList({
  Empty = SelectDropdownEmpty,
  Footer,
  Header,
  InitialLoader = SelectDropdownAsyncListInitialLoader,
  Item = SelectDropdownEntityListItem,
  ListContainer = SelectDropdownListContainer,
  MoreItemsLoader = LoaderListItem,
  className = styles.SelectDropdownAsyncList,
  disabled,
  elementsRef,
  emptyProps,
  footerProps,
  getThresholdItemProps,
  headerProps,
  initialLoaderProps,
  itemProps,
  listContainerProps,
  loadingInitial,
  loadingMore,
  moreItemsLoaderProps,
  options,
  showFooter = showSelectDropdownAsyncListFooter,
  showHeader = showSelectDropdownAsyncListHeader,
  ...restProps
}) {
  const listClassName = classNames(className, {
    [styles.withoutItems]: !Number.isFinite(options?.length),
  })

  const listContainerClassName = classNames(
    listContainerProps?.className || styles.selectDropdownAsyncListContainer,
    {
      [styles.loadingInitial]: loadingInitial,
    }
  )

  return (
    <div {...restProps} className={listClassName}>
      {showHeader({ Header, options }) ? (
        <Header {...headerProps} disabled={disabled || loadingInitial} />
      ) : null}

      <ListContainer {...listContainerProps} className={listContainerClassName}>
        {loadingInitial ? <InitialLoader {...initialLoaderProps} /> : null}

        {options?.length > 0 ? (
          <FloatingList elementsRef={elementsRef}>
            {options.map((option, index) => (
              <Item
                {...itemProps}
                {...getThresholdItemProps?.(index)}
                disabled={disabled}
                key={option.value ? `${option.value}-${index}` : index}
                value={option}
              />
            ))}
            {loadingMore ? <MoreItemsLoader {...moreItemsLoaderProps} /> : null}
          </FloatingList>
        ) : (
          <Empty {...emptyProps} />
        )}
      </ListContainer>

      {showFooter({ Footer, options }) ? (
        <Footer {...footerProps} disabled={disabled || loadingInitial} />
      ) : null}
    </div>
  )
}

export default SelectDropdownAsyncList
